import moment from 'moment';

import { Instant, LocalDate } from '../adl-gen/common';

const CENTIMETERS_PER_INCH = 2.54;

/**
 * Formats an Instant in milliseconds since epoch into the given string format
 */
export function formatInstant(milliseconds: Instant, format: string): string {
  return moment(milliseconds).format(format);
}

/**
 * Formats a local date into a given string format.
 */
export function formatDate(date: LocalDate, format: string): string {
  return moment(date, 'YYYY-MM-DD').format(format);
}

/**
 * Formats an ABN number to be displayed with spaces
 */
export function formatABN(abn: string): string {
  return abn.slice(0, 2) + ' ' + abn.slice(2, 5) + ' ' + abn.slice(5, 8) + ' ' + abn.slice(8, 11);
}

/**
 * Formats a phone number
 */
export function formatPhoneNumber(phoneNumber: string) {
  if (phoneNumber.length === 10) {
    return '(' + phoneNumber.slice(0, 2) + ') ' + phoneNumber.slice(2, 6) + ' ' + phoneNumber.slice(6, 10);
  } else {
    return phoneNumber;
  }
}

/** Converts inches to centimeters (no precision changes) */
export function inchesToCentimeters(inches: number): number {
  return inches * CENTIMETERS_PER_INCH;
}

/** Converts centimeters to inches (no precision changes) */
export function centimetersToInches(centimeters: number): number {
  return centimeters / CENTIMETERS_PER_INCH;
}

/** Formats a ratio as a percentage */
export function formatPercentage(ratio: number): string {
  return Math.round(ratio * 100) + '%';
}



// WEBPACK FOOTER //
// ./src/util/formatters.ts